import React from "react";
import _ from "lodash";

import { useSelector } from "react-redux";

import checkRouteAccess from "helpers/checkRouteAccess";
import RouteLoadingIndicator from "components/RouteLoadingIndicator/RouteLoadingIndicator";

import useRouteConfig from "@src/hooks/useRouteConfig";

import AuthenticationError from "../components/AuthenticationError/AuthenticationError.component";

import routesObject from "../routesObject";


interface RouteAuthorizationProps {
  children: React.ReactNode;
}

function RouteAuthorization({ children }: RouteAuthorizationProps) {
  const routeItem = useRouteConfig();
  const customerStatus = useSelector(state => _.get(state, "app.memberDetails.status"));
  const initInProgress = useSelector((state) => _.get(state, "app.initInProgress"));

  if (initInProgress) {
    return <RouteLoadingIndicator />;
  }

  // No route found or error route, will be default to error route so we render children
  if (!routeItem || routeItem.key === routesObject.error.key) {
    return <>{children}</>;
  }

  const accessResult = checkRouteAccess(routeItem, customerStatus);

  if (accessResult.accessGranted) {
    return <>{children}</>;
  }
  else {
    return (
      <AuthenticationError
        customerStatus={customerStatus}
        activeRoute={routeItem}
        redirectTo={accessResult.redirectTo} />
    );
  }
}

export default RouteAuthorization;
